import BaseAPI from './base/base-api';

class PayTaxPaymentAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'PaymentAPI';
	controllerName = 'paytaxpaymentsubmission';
}

export default new PayTaxPaymentAPI();
